import React, { ReactNode, useEffect } from 'react';
import { ArrowLeft } from '@components/Common/Icons';
import styles from './styles.module.scss';
import cN from 'classnames';

interface I_SlidePage {
    visible: boolean;
    setIsVisible: (visible: boolean) => void;
    title: string;
    children: React.ReactNode;
    isHeaderShow?: boolean;
}

const SlidePage: React.FC<I_SlidePage> = ({
    visible,
    children,
    title,
    setIsVisible,
    isHeaderShow = true,
}) => {
    useEffect(() => {
        const body = document.querySelector('body');
        if (!body) return;
        if (visible) {
            body.style.overflow = 'hidden';
        } else {
            body.style.overflow = '';
        }
    }, [setIsVisible]); //SlidePage在M版進階篩選、目的地光箱元件都會用到depency副作用特別注意
    return (
        <div className={cN(styles.slidePage, styles[visible ? 'open' : ''])}>
            {isHeaderShow && (
                <div className={styles.header}>
                    <div className={styles.goBack} onClick={() => setIsVisible(false)}>
                        <ArrowLeft fill="#fff" />
                    </div>
                    <div className={styles.title}>{title}</div>
                </div>
            )}
            <div className={cN(styles.content, 'contentBox')}>{children}</div>
        </div>
    );
};

export default SlidePage;
